import { alpha, styled } from '@mui/material';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid2 from '@mui/material/Grid2';
import ImageListItem, {
  imageListItemClasses,
} from '@mui/material/ImageListItem';
import ImageListItemBar, {
  imageListItemBarClasses,
} from '@mui/material/ImageListItemBar';
import RadioGroup from '@mui/material/RadioGroup';
import Stack from '@mui/material/Stack';

import CONFIG from '@webclient/components/pages/home/sections/bots/list/config';

import { Radio } from '@knowz/knowz-ui';

export const StyledListItemBar = styled(ImageListItemBar)(({ theme }) => ({
  background: alpha(
    theme.palette.mode === 'dark'
      ? theme.palette.common.black
      : theme.palette.common.white,
    0.7,
  ),
  height: theme.spacing(13),
  backdropFilter: 'blur(10px)',
  boxShadow: `inset 0px 0px 0px 1px ${theme.palette.border.secondary}`,
  margin: theme.spacing(0.5),
  borderTopLeftRadius: theme.shape.borderRadius * 0.5,
  borderTopRightRadius: theme.shape.borderRadius * 6,
  borderBottomLeftRadius: theme.shape.borderRadius * 6,
  borderBottomRightRadius: theme.shape.borderRadius * 6,
  [`.${imageListItemBarClasses.titleWrap}`]: {
    padding: theme.spacing(2),
  },
  [`.${imageListItemBarClasses.subtitle}`]: {
    textOverflow: 'unset',
    whiteSpace: 'unset',
    textAlign: 'center',
    userSelect: 'none',
    color: theme.palette.text.primary,
  },
}));

export const StyledImageListItem = styled(ImageListItem)<{
  selected?: boolean;
}>(({ theme, selected }) => ({
  width: CONFIG.IMAGE_WIDHT,
  height: `${CONFIG.IMAGE_HEIGHT}px!important`,
  [`& .${imageListItemClasses.root}`]: {
    ...(selected && {
      border: `2px solid ${theme.palette.warning[300]}`,
      boxShadow: theme.shadows[3],
    }),
    borderRadius: theme.shape.borderRadius * 6,
    img: {
      borderRadius: theme.shape.borderRadius * 5.5,
    },
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
})) as any; //TODO: fix type error

export const StyledHiddenPositionedRadio = styled(Radio)(() => ({
  position: 'absolute',
  top: 10,
  left: 10,
  zIndex: 1,
  opacity: 0,
}));

const FULLY_ROUNDED = 99999;

export const StyledNameStack = styled(Stack)(({ theme }) => ({
  flexDirection: 'row',
  color: theme.palette.utility.gray900,
  background: alpha(
    theme.palette.mode === 'dark'
      ? theme.palette.common.black
      : theme.palette.common.white,
    0.7,
  ),
  backdropFilter: 'blur(10px)',
  boxShadow: `inset 0px 0px 0px 1px ${theme.palette.border.secondary}`,
  position: 'absolute',
  borderRadius: FULLY_ROUNDED,
  padding: theme.spacing(1, 2),
  top: 10,
  left: '50%',
  transform: 'translateX(-50%)',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  maxWidth: '85%',
})) as typeof Stack;

export const StyledFormControl = styled(FormControl)(({ theme }) => ({
  width: '100%',
  userSelect: 'none',
  [theme.breakpoints.up('md')]: {
    width: '100%',
  },
}));

export const StyledImageList = styled(Grid2)(({ theme }) => ({
  padding: theme.spacing(0.5),
  justifyContent: 'center',
  [theme.breakpoints.up('md')]: {
    justifyContent: 'flex-start',
  },
}));

export const StyledRadioGroup = styled(RadioGroup)(() => ({}));

export const StyledFormControlLabel = styled(FormControlLabel)(() => ({
  width: '100%',
  justifyContent: 'center',
}));

export const StyledVideo = styled('video')(({ theme }) => ({
  borderRadius: theme.shape.borderRadius * 5.5,
  width: '100%',
  height: '100%',
}));

export const StyledImg = styled('img')(() => ({
  height: '100%',
  objectFit: 'cover',
}));

export const StyledButton = styled('button')(({ theme }) => ({
  position: 'absolute',
  bottom: '85%',
  left: 0,
  backdropFilter: 'blur(10px)',
  borderRadius: '50%',
  border: 'none',
  width: 24,
  height: 24,
  cursor: 'pointer',
  color: theme.palette.text.primary,
  background:
    theme.palette.mode === 'dark'
      ? theme.palette.common.black
      : theme.palette.common.white,
  zIndex: 1,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const StyledIconBox = styled('div')(() => ({
  fontSize: '0.85em',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));
